
import React from 'react';
import { Toaster } from 'sonner';

interface NotificationsProps {
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  theme?: 'light' | 'dark' | 'system';
}

export const Notifications: React.FC<NotificationsProps> = ({ 
  position = 'top-right',
  theme = 'system'
}) => {
  return (
    <Toaster
      position={position}
      theme={theme}
      richColors
      closeButton
      expand={true}
      visibleToasts={5}
      toastOptions={{
        className: 'notification-toast',
        duration: 5000,
      }}
    />
  );
};

export default Notifications;
